<template>
	<section class="register">
		<form @submit.prevent="checkRegister">
			<ManagingSection>
				<ManagingBox v-if="type === 'modify'" title="번호">
					<p>{{ serviceId }}</p>
				</ManagingBox>
				<ManagingBox v-if="type === 'modify'" title="상태">
					<P>{{ serviceStatus }}</P>
				</ManagingBox>
				<ManagingBox title="점검시간">
					<DateRange v-model="dateRange" />
				</ManagingBox>
				<ManagingBox title="내용">
					<textarea
						class="register__textarea"
						v-model="message"
					></textarea>
				</ManagingBox>
				<div class="btn-wrap-main">
					<button type="submit" class="btn-main blue">
						{{ type === 'register' ? '등록' : '수정' }}
					</button>
					<button type="button" class="btn-main" @click="init">
						초기화
					</button>
				</div>
			</ManagingSection>
		</form>
	</section>
</template>
<script>
	import moment from 'moment';
	import DateRange from '../../components/DateRange.vue';
	import ManagingBox from '../../components/layout/ManagingBox.vue';
	import ManagingSection from '../../components/layout/ManagingSection.vue';
	export default {
		components: { ManagingSection, ManagingBox, DateRange },
		data() {
			return {
				dateRange: { from: '', to: '' },
				message: '',
				type: 'register',
				serviceId: '',
				serviceStatus: '',
				status: {
					READY: '진행대기',
					STARTED: '진행중',
					FINISHED: '진행완료',
				},
			};
		},
		created() {
			if (this.$route.params.idServiceCheck) {
				this.type = 'modify';
				this.init();
				this.getDetail();
			}
		},
		methods: {
			async checkRegister() {
				try {
					const { from, to } = this.dateRange;
					const { message } = this;
					if (!this.validation()) return;
					if (this.checkEnd()) {
						alert('종료된 서비스는 수정할 수 없습니다.');
						return;
					}
					const params = {
						startAt: moment(from).valueOf(),
						endAt: moment(to).valueOf(),
						content: message,
						type: 'SERVICE',
					};
					if (this.type === 'modify') {
						params.id = this.serviceId;
					} else {
						delete params.id;
					}
					await this.$axiosAdmin2.post(
						'/api/operation/maintenance',
						params
					);
					alert(
						`${this.type === 'modify' ? '수정' : '등록'}되었습니다.`
					);
					this.init();
					this.$router.push('/operation/service-check');
				} catch (error) {
					console.error(error);
					alert('등록에 실패했습니다.');
				}
			},
			async getDetail() {
				try {
					const { data } = await this.$axiosAdmin2.get(
						`/api/operation/maintenance/${this.$route.params.idServiceCheck}`
					);
					this.dateRange = {
						from: moment(data.startAt).format('YYYY-MM-DD HH:mm'),
						to: moment(data.endAt).format('YYYY-MM-DD HH:mm'),
					};
					this.message = data.content;
					this.serviceId = data.id;
					this.serviceStatus = this.status[data.status];
				} catch (error) {
					console.error(error);
					alert('데이터를 불러오는데 실패했습니다.');
				}
			},
			checkEnd() {
				return this.serviceStatus === '진행완료' ? true : false;
			},
			validation() {
				const { from, to } = this.dateRange;
				const { message } = this;
				if (!from) {
					alert('시작일을 입력해주세요.');
					return false;
				}
				if (!to) {
					alert('종료일을 입력해주세요.');
					return false;
				}
				if (from > to) {
					alert('시작일이 종료일보다 빠를 수 없습니다.');
					return false;
				}
				if (!message) {
					alert('내용을 입력해주세요.');
					return false;
				}
				return true;
			},
			init() {
				this.dateRange = { from: '', to: '' };
				this.message = '';
			},
		},
	};
</script>
<style lang="scss" scoped></style>
